import { BlockVehicleGrid } from "./js/grid";
import { BlockVehicleSlider } from "./js/slider";

export function initVehicleTeaser() {
    return [...document.querySelectorAll('.b-vehicles-teaser.grid-type:not(.-initialized)')].map(node => new BlockVehicleGrid(node))
}

export function initBlockVehicleSlider() {
    [...document.querySelectorAll(".splide.vehicleslider")].map((el) => new BlockVehicleSlider(el));
}
